import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from '../reducers/index';

const store = createStore(reducers, applyMiddleware(thunk));

// 打印初始状态
export default store;
